var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"pl-10 pr-10 ml-0"},[_c('MembershipManage')],1),_c('PageLoadingProgress',{ref:"PageLoadingProgress"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }